import {
  Timestamp,
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
  where,
} from 'firebase/firestore'

import converter from './storyConverter'
import type { DSStory } from '~/types'

export default function useStoriesSortedByUpdated(topicId: string, defaultPerPage = 10) {
  const db = useFirestore()
  const modelConverter = converter()
  const storyCollection = collection(db, 'stories')
  const lastVisible = useState<Timestamp | null>(`lastVisibleStory-${topicId}`, () => null)
  const hasMoreStories = useState<boolean>(`hasMoreStories-${topicId}`, () => true)
  const isCrawler = useState<boolean>('isCrawler')
  const perPage = computed(() => isCrawler.value ? 1000 : defaultPerPage)

  const loadNextStories = async (accumulatedList = []) => {
    let q
    const tempList = []

    if (lastVisible.value === null || accumulatedList.length === 0) {
      q = query(
        storyCollection,
        where('topicId', '==', topicId),
        orderBy('updated', 'desc'),
        limit(perPage.value),
      ).withConverter(modelConverter)
    } else {
      lastVisible.value = new Timestamp(lastVisible.value.seconds, lastVisible.value.nanoseconds)

      q = query(
        storyCollection,
        where('topicId', '==', topicId),
        orderBy('updated', 'desc'),
        limit(perPage.value),
        startAfter(lastVisible.value),
      ).withConverter(modelConverter)
    }

    const result = await getDocs(q)
    const lastDocRef = result.docs[result.docs.length - 1]

    if (result.docs.length < perPage.value)
      hasMoreStories.value = false

    if (!lastDocRef)
      return []

    lastVisible.value = (lastDocRef?.data() as DSStory)?.updated

    result.forEach((doc) => {
      tempList.push({ id: doc.id, ...doc.data() })
    })

    return tempList
  }

  return {
    hasMoreStories,
    loadNextStories,
  }
}
